// PRODUCT-26110 Task 14: previously installed via the legacy `this.options.Vue.use(...)`
// global singleton (see createModalPlugin.ts's identical comment) -- now a real Vue 3
// `Plugin` (`install(app: App)`), applied via `app.use(...)` against the actual
// `createApp()` instance in dashboard-commons/app/internals/Application.ts's `mount()`.
import type { App } from 'vue';

import ProcedureManager from './ProcedureManager';
import { ProcedureComponentMap } from './types';

function createProcedurePlugin<T extends Record<string, any>>(views: ProcedureComponentMap<T>) {
    return {
        install(app: App): void {
            app.mixin({
                beforeCreate() {
                    if (this === this.$root) {
                        Object.defineProperty(this, '$procedures', {
                            value: new ProcedureManager(views),
                        });
                    } else {
                        // Object.defineProperty on the public proxy actually writes onto
                        // instance.ctx, so inside the getter `this` is ctx, not the proxy --
                        // and prod-build ctx has no `$root` (only dev's does). Capture the
                        // root here, while `this` is still the proxy, and close over it.
                        const root = this.$root;
                        Object.defineProperty(this, '$procedures', {
                            get: () => root.$procedures,
                        });
                    }
                },
            });
        },
    };
}

export default createProcedurePlugin;
